import { auth, destroy, getWithConfig, put } from "../config/api";
import { ServerData } from "../helpers/Service";

export const TOKEN_KEY = "access-token";
export const CLIENT = "client";
export const UID = "uid";
export const USER = "user";
export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getClient = () => localStorage.getItem(CLIENT);
export const getUid = () => localStorage.getItem(UID);
export const getUser = () => localStorage.getItem(USER);

export const logoutAtendente = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(CLIENT);
  localStorage.removeItem(UID);
  localStorage.removeItem(USER);
};

export interface UserProfile {
  id: number;
  name: string | null;
  email: string;
  activities: string[];
}

export interface PasswordChangeForm {
  currentPassword: string;
  password: string;
  passwordConfirmation: string;
}

const authHeaders = () => ({
  "Access-Token": getToken(),
  client: getClient(),
  Uid: getUid(),
});

export default class AuthService {
  public static async autenticar(email: string, password: string) {
    return auth<ServerData<Boolean>>("/auth/sign_in", { email, password }
    ).then((response) => response);
  }

  public static async adminProfile() {
    return getWithConfig<UserProfile>("/admin/me", { headers: authHeaders() })
      .then((response) => response.data);
  }

  public static async attendantProfile() {
    return getWithConfig<UserProfile>("/atendente/me", { headers: authHeaders() })
      .then((response) => response.data);
  }

  public static async changePassword(form: PasswordChangeForm) {
    return put<void>("/admin/senha", form, { headers: authHeaders() });
  }

  public static async logout() {
    try {
      await destroy("/auth/sign_out", { headers: authHeaders() });
    } finally {
      logoutAtendente();
    }
  }
}
